import { useMedia } from 'react-use';
import { useKeenSlider } from 'keen-slider/react';

import {
    StyledSection,
    StyledHeading,
    TextContainer,
    StyledContainer,
    LinkContainer,
    StyledLinkReadMore,
    SliderControlDiv,
} from './styles';
import BlogItem from '../../components/BlogItem/BlogItem';
import React, { useState } from 'react';

export interface BlogSectionProps {
    title: string;
    blogs: BlogItem[];
}

function Arrow(props: { disabled: boolean; left?: boolean; onClick: (e: any) => void }) {
    const disabeld = props.disabled ? ' arrow--disabled' : '';
    return (
        <svg
            onClick={props.onClick}
            className={`arrow ${props.left ? 'arrow--left' : 'arrow--right'} ${disabeld}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            {props.left && (
                <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
            )}
            {!props.left && <path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z" />}
        </svg>
    );
}

const BlogSection = ({ title, blogs }: BlogSectionProps) => {
    //TODO  move breakpoint to cosntants
    const isMobile = useMedia('(max-width: 780px)');

    const [currentSlide, setCurrentSlide] = React.useState(0);
    const [loaded, setLoaded] = useState(false);
    const [keenSliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        loop: true,
        initial: 0,
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    return (
        <>
            <StyledSection>
                <TextContainer>
                    <StyledHeading>{title}</StyledHeading>
                </TextContainer>
                {isMobile ? (
                    <>
                        <div ref={keenSliderRef} className="keen-slider">
                            {blogs.map((blogitem, index) => (
                                <div
                                    key={index}
                                    className={`keen-slider__slide number-slide${index}`}
                                >
                                    <BlogItem
                                        title={blogitem.title}
                                        image={blogitem.image}
                                        link={blogitem.link}
                                        key={index}
                                    />
                                </div>
                            ))}
                        </div>
                        <SliderControlDiv>
                            {loaded && instanceRef.current && (
                                <>
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            width: '20px',
                                        }}
                                    >
                                        <Arrow
                                            left
                                            onClick={(e: any) =>
                                                e.stopPropagation() || instanceRef.current?.prev()
                                            }
                                            disabled={currentSlide === 0}
                                        />
                                    </div>
                                    <span
                                        style={{
                                            margin: '0px 30px',
                                        }}
                                    >
                                        {currentSlide + 1} / {blogs.length}{' '}
                                    </span>
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            width: '20px',
                                        }}
                                    >
                                        <Arrow
                                            onClick={(e: any) =>
                                                e.stopPropagation() || instanceRef.current?.next()
                                            }
                                            disabled={
                                                currentSlide ===
                                                instanceRef.current.track.details.slides.length - 1
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </SliderControlDiv>
                    </>
                ) : (
                    <StyledContainer>
                        {blogs.map((blogitem, index) => (
                            <BlogItem
                                title={blogitem.title}
                                image={blogitem.image}
                                link={blogitem.link}
                                key={index}
                            />
                        ))}
                    </StyledContainer>
                )}
                <LinkContainer>
                    <StyledLinkReadMore target="_blank" href="https://www.idosell.com/pl/blog/">
                        Przeczytaj wpisy na naszym blogu
                    </StyledLinkReadMore>
                </LinkContainer>
            </StyledSection>
        </>
    );
};

export default BlogSection;
